import { defineMapper } from '@/common/application/mappers/kit/mapperFactory';
import type { SpacerContent } from '@/blocks/domain/types/BlockContent/SpacerContent';
import type { BlockContentDto } from '@/blocks/application/mappers/blockMapper';

type SpacerDto = Extract<BlockContentDto, { kind: 'spacer' }>;

const spacerMapper = defineMapper<SpacerDto, SpacerContent>({
  toView: (dto) => ({ kind: 'spacer', heightPx: dto.height_px }),
  toRequest: (content) => ({ kind: 'spacer', height_px: content.heightPx })
});

export function mapSpacerContent(dto: SpacerDto): SpacerContent {
  return spacerMapper.toView(dto);
}

export function fromSpacerContent(content: SpacerContent): SpacerDto {
  return spacerMapper.toRequest(content);
}

export { spacerMapper };
